import { isEmpty } from 'lodash';

// Names the pipeline-variable resolution the test run will use — otherwise
// mapDefaultValue's fallback to defaultValue/example values is invisible and
// a test can deliver placeholder values to a real vendor without warning.
// Variable values are intentionally never shown (matches PipelineVariablesCell).
export default function buildPipelineVariablesNote({ pipelineVariables, attachment, pipelineName }) {
  if (isEmpty(pipelineVariables)) {
    return null;
  }

  if (!attachment) {
    return {
      severity: 'warning',
      message: `This integration is not attached to pipeline "${pipelineName}" — pipeline variables were not applied; playbook defaults were used.`,
    };
  }

  const stagedValues = attachment.stagedRevision?.pipelineVars ?? {};
  // Truthiness mirrors mapDefaultValue: '' and null both fall back to the default.
  const unsatisfied = pipelineVariables.map(variable => variable.name).filter(name => !stagedValues[name]);

  if (isEmpty(unsatisfied)) {
    return {
      severity: 'info',
      message: `Pipeline variables applied from pipeline "${pipelineName}" (staged configuration).`,
    };
  }

  const noun = unsatisfied.length === 1 ? 'variable has' : 'variables have';
  return {
    severity: 'warning',
    message: `${
      unsatisfied.length
    } pipeline ${noun} no value on pipeline "${pipelineName}" — using playbook defaults: ${unsatisfied.join(', ')}.`,
  };
}
